import { t } from "@lingui/core/macro";
import { useAtomValue } from "jotai";

import { ClubLogo } from "@/components/ClubLogo/ClubLogo";
import { ClubLogo_Club$key } from "@/components/ClubLogo/__generated__/ClubLogo_Club.graphql";
import { Button } from "@whoosh/design-system/src/components/controls";
import { CloseIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { PanelHeader } from "@whoosh/design-system/src/components/layout/PanelHeader";

import { DiningBookingWizardCurrentStepAtom } from "../../atoms/stores";

export const DiningBookingWizardHeader = ({
  clubName,
  onClose,
  club,
}: {
  clubName: string;
  onClose: () => void;
  club?: ClubLogo_Club$key | null;
}) => {
  const currentStep = useAtomValue(DiningBookingWizardCurrentStepAtom);
  const panelHeader =
    currentStep === "DiningAddKnownPeopleStep"
      ? t`Who are you coming with?`
      : t`New Reservation`;
  return (
    <PanelHeader
      paddingVariant="medium"
      header={panelHeader}
      subHeader={clubName}
      outerLeftComponent={
        <Button
          testID="modal-close-btn"
          variant="secondary"
          accessibilityLabel={t`Close button`}
          onPress={onClose}
          leftIcon={<CloseIcon />}
        />
      }
      outerRightComponent={club ? <ClubLogo clubRef={club} /> : null}
    />
  );
};
